var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('a',{attrs:{"href":"http://www.facturando.mx/"}},[_vm._v("Administrador")]),_vm._v(" © 2017 Facturando.\n  "),_c('span',{staticClass:"float-right"},[_vm._v("Creado por "),_c('a',{attrs:{"href":"http://www.facturando.mx/"}},[_vm._v("Facturando")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55c5e5de","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 771
// module chunks = 7